module.exports = __webpack_public_path__ + "img/cs-iosclub-5.441cda92.jpg";